/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import _Object$keys from"@babel/runtime-corejs3/core-js-stable/object/keys";import isFunction from"./isFunction";const keys=function(e){let t=[];if(isFunction(_Object$keys))return _Object$keys(e);for(var r in e)e.hasOwnProperty(r)&&t.push(r);return t};export default keys;